/**
 * BrandIcon — website version
 * Aceita emoji, "si:slug" (simple-icons) ou URL de imagem.
 */
import React, { useMemo } from 'react';

function slugToKey(slug) {
  return 'si' + slug.split(/[-_]/).map(w => w.charAt(0).toUpperCase() + w.slice(1)).join('');
}

export default function BrandIcon({ icon, size = 24, color, style = {}, className }) {
  const resolved = useMemo(() => {
    if (!icon) return null;
    const str = typeof icon === 'string' ? icon.trim() : String(icon);
    if (str.startsWith('http') || str.startsWith('/')) return { type: 'img', src: str };
    if (str.startsWith('si:')) {
      const slug = str.slice(3).toLowerCase().replace(/\s+/g, '');
      try {
        const si = require('simple-icons');
        const iconData = si[slugToKey(slug)];
        if (iconData) return { type: 'svg', path: iconData.path, hex: iconData.hex, title: iconData.title };
      } catch {}
      return { type: 'emoji', value: '🔌' };
    }
    return { type: 'emoji', value: str };
  }, [icon]);

  if (!resolved) return null;

  const base = { display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, ...style };

  if (resolved.type === 'img') return <img src={resolved.src} alt="" width={size} height={size} style={{ objectFit: 'contain', borderRadius: 4, ...style }} className={className} />;

  if (resolved.type === 'svg') {
    const fill = color || `#${resolved.hex}`;
    return (
      <svg role="img" viewBox="0 0 24 24" width={size} height={size} fill={fill} style={base} className={className} aria-label={resolved.title}>
        <path d={resolved.path} />
      </svg>
    );
  }

  return <span style={{ fontSize: size * 0.85, lineHeight: 1, ...base }} className={className} aria-hidden="true">{resolved.value}</span>;
}
